export default "__VITE_ASSET__DdhJCxel__"